export default "__VITE_ASSET__CfPyhR9k__"